var render = function render(_c,_vm){return _c('div',[_c('h1',{class:_vm.$style.text},[_vm._t("default")],2),_c('div',{class:_vm.$style.line})])
}
var staticRenderFns = []

export { render, staticRenderFns }